import { getRequest, postRequest, patchRequest, deleteRequest } from './api';
import { STORAGE_KEYS } from '../config/constants';

const getManagerMeta = () => {
  const userId = localStorage.getItem(STORAGE_KEYS.USER_ID);
  const userDataStr = localStorage.getItem(STORAGE_KEYS.USER_DATA);
  const userData = userDataStr ? JSON.parse(userDataStr) : null;
  // Admin uses pincode inq servingPinCodes — same here
  const servingPinCodes = userData?.servingPinCodes || [];
  return { userId, servingPinCodes };
};

export const partnerService = {
  // Get all partners whose pincode is in manager's servingPinCodes
  // (matches admin PartnerManger.jsx query exactly)
  getPartners: async (filters = {}) => {
    try {
      const { servingPinCodes } = getManagerMeta();
      console.log(servingPinCodes, 'servingPinCodes in partnerService.getPartners');
      const { where: filtersWhere, ...restFilters } = filters || {};
      const filter = {
        where: {
          userType: 'partner',
          pincode: { inq: servingPinCodes },
          ...filtersWhere,
        },
        include: [{ relation: 'services' }],
        order: 'createdAt DESC',
        ...restFilters,
      };

      const response = await getRequest(`users?filter=${JSON.stringify(filter)}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Search partners by mobile number
  searchPartners: async (searchText) => {
    try {
      const { servingPinCodes } = getManagerMeta();

      const filter = {
        where: {
          userType: 'partner',
          pincode: { inq: servingPinCodes },
          mobileNumber: { regexp: `/${searchText}/i` },
        },
        include: [{ relation: 'services' }],
      };

      const response = await getRequest(`users?filter=${JSON.stringify(filter)}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get single partner by ID
  getPartnerById: async (partnerId) => {
    try {
      const response = await getRequest(`users/${partnerId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create new partner
  createPartner: async (partnerData) => {
    try {
      const { userId } = getManagerMeta();

      const payload = {
        ...partnerData,
        userType: 'partner',
        managerId: userId,
        status: 'unverified',
      };

      const response = await postRequest('users', payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update partner
  updatePartner: async (partnerId, partnerData) => {
    try {
      const response = await patchRequest(`users/${partnerId}`, partnerData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete partner
  deletePartner: async (partnerId) => {
    try {
      const response = await deleteRequest(`users/${partnerId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update partner status (verify/reject)
  updatePartnerStatus: async (partnerId, status) => {
    try {
      const response = await patchRequest(`users/${partnerId}`, { status });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get count of partners in manager's pincodes
  getPartnersCount: async (whereFilter = {}) => {
    try {
      const { servingPinCodes } = getManagerMeta();

      const where = {
        userType: 'partner',
        pincode: { inq: servingPinCodes },
        ...whereFilter,
      };

      const response = await getRequest(`users/count?where=${JSON.stringify(where)}`);
      return response.count || 0;
    } catch (error) {
      console.warn('Count endpoint not available:', error);
      return 0;
    }
  },
};

export default partnerService;
